import { Component, EventEmitter, Input, Output } from '@angular/core';
import { hexToRgba } from 'src/app/common/colorUtils';
import { formatFromDate } from 'src/app/common/datetime_utility';
import { LabelBindingModel, LabelModel } from 'src/app/models/api/common';

@Component({
  selector: 'app-view-selected-label',
  templateUrl: './view-selected-label.component.html',
  styleUrls: ['./view-selected-label.component.scss'],
})
export class ViewSelectedLabelComponent {
  @Input() public labelBinding: LabelBindingModel;
  @Input() public label: LabelModel;
  @Input() public canBeRemoved = true;
  @Output() public removeLabelEventEmitter: EventEmitter<LabelBindingModel> = new EventEmitter<LabelBindingModel>();

  public getLabelTransparentBackgroundColor(): string {
    return hexToRgba(this.label.color, 0.3);
  }

  public clearSingleOption() {
    this.removeLabelEventEmitter.emit(this.labelBinding);
  }

  public getLabelNote(): string {
    let label_note = '';
    if (this.labelBinding.userActionTimestamps) {
      label_note =
        formatFromDate(this.labelBinding.userActionTimestamps.createdAt) +
        '\n' +
        'Created by: ' +
        this.labelBinding.userActionTimestamps.createdBy;
    } else if (this.labelBinding.mergedLabels) {
      label_note = this.labelBinding.mergedLabels.map((label: LabelBindingModel) => label.label.displayName).join(', ');
    }
    if (this.labelBinding.description) label_note += '\n' + 'Description: ' + this.labelBinding.description;

    return label_note;
  }
}
